// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2731":"d8841474718ad10f2641","6318":"09837f7a14517cac999d"}[chunkId] + ".js";
};